<template>
	<div>
		<el-dialog :title="$t('subscribe.title')" :visible="isShowSubscribe" :before-close="subscribeClose"
			class="AddSubscribeOrderdemodialog" width="90%" top="1vh" append-to-body modal-append-to-body @open="open">
			<el-form :model="subscribeOrder" ref="subscribeOrder" :inline="true" label-width="200px"
				class="demo-shopform">
				<el-form-item :label="$t('subscribe.labellist[3]')" prop="name"><el-input v-model="subscribeOrder.num"
						disabled></el-input></el-form-item>
				<el-form-item :label="$t('subscribe.labellist[2]')" prop="applydt"><el-input
						v-model="subscribeOrder.applydt" disabled></el-input></el-form-item>

				<el-form-item :label="$t('subscribe.labellist[18]')" prop="purchaseType"><el-input
						v-model="subscribeOrder.purchaseType" disabled></el-input></el-form-item>

				<el-form-item :label="$t('subscribe.labellist[7]')"
					:rules="{ required: true, message: $t('subscribe.errmsg[1]') }">
					<el-select v-model="subscribeOrder.currencyid" @change="currencyChange"
						:disabled="isEdit === true || isLook === true" :placeholder="$t('SupplierClass.placeholder')"
						style="width: 190px">
						<el-option v-for="(item, index) in currencyList" :key="item + index" :label="item.ShortEng"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('GoodsList.dialog[14]')" :rules="{
            required: true,
            message: $t('GoodsList.dialog[14]') + ' ' + $t('depart.msg[1]')
          }">
					<el-select v-model="subscribeOrder.purid" @change="purchaseCategoryChange"
						:placeholder="$t('SupplierClass.placeholder')" style="width: 190px"
						:disabled="isEdit == true || isLook === true">
						<el-option v-for="(item, index) in purchaseClass" :key="index" :label="item.purgoods_En"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>

				<!-- 	<el-form-item :label="$t('subscribe.labellist[21]')">
					<el-input :value="deptBudget.totalPurAmount + deptBudget.shortEng" disabled></el-input>
				</el-form-item> -->
				<el-form-item :label="$t('subscribe.labellist[21]')" v-if="false">
					<el-input :value="subscribeOrder.budgetMoney + deptBudget.shortEng" disabled></el-input>
				</el-form-item>

				<el-form-item :label="$t('subscribe.labellist[25]')">
					<!-- <el-input :value="isEdit || isLook ? subscribeOrder.budgetMoney + deptBudget.shortEng : CurrentBudgetAmount + deptBudget.shortEng" disabled></el-input> -->
					<el-input v-if="deptBudget.length > 0" :value="
              isEdit || isLook
                ? subscribeOrder.budgetMoney + deptBudget[0].shortEng
                : CurrentBudgetAmount + deptBudget[0].shortEng
            " disabled></el-input>

					<el-input v-else :value="
              isEdit || isLook
                ? subscribeOrder.budgetMoney
                : CurrentBudgetAmount
            " disabled></el-input>
				</el-form-item>
				<el-form-item :label="$t('subscribe.labellist[26]')"><el-input
						:value="isEdit || isLook ? subscribeOrder.money : OrderTTLAmount"
						disabled></el-input></el-form-item>

				<!-- <el-form-item :label="$t('subscribe.labellist[31]')"><el-input :value="subscribeOrder.GroupID" disabled></el-input></el-form-item> -->
				<!-- 暂时取消 -->
				<el-form-item :disabled="isLook === true || subscribeOrder.isComplete !== 0"
					:label="$t('subscribe.labellist[32]')" :rules="{
            required: true,
            message: $t('subscribe.labellist[32]') + ' ' + $t('depart.msg[1]')
          }">
					<el-select v-model="subscribeOrder.GroupName" @change="laborGroupChange" style="width: 190px"
						:disabled="isLook === true || subscribeOrder.isComplete !== 0">
						<el-option v-for="(item, index) in UserGroupList" :key="index" :label="item.groupName"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="" class="formtable" style="width: 100%">
					<el-table :data="deptBudget" style="width: 100%" :empty-text="$t('header.tableEmpty')" stripe
						border>
						<el-table-column show-overflow-tooltip align="center" v-for="(item, index) in tableHead"
							:key="index" :prop="item.prop" :label="item.label" width="200"></el-table-column>

						<el-table-column align="center" :label="$t('subscribe.labellist[24]')" prop="withoutAfterAmount"
							show-overflow-tooltip>
							<template slot-scope="scope">
								<!-- <div :style="scope.row.redtext == true?'{color:red}':'{color:blue}'">{{scope.row.withoutAfterAmount}}</div> -->
								<div :style="{
                    color: scope.row.redtext == true ? '#ff0000' : '#000000'
                  }">
									{{ scope.row.withoutAfterAmount }}
								</div>
							</template>
						</el-table-column>

						<el-table-column align="center" :label="$t('subscribe.labellist[23]')" prop="ApprovedAmount"
							show-overflow-tooltip></el-table-column>

						<el-table-column align="center" :label="$t('subscribe.statelist[9]')" prop="currentBudgetAmount"
							show-overflow-tooltip></el-table-column>

						<el-table-column align="center" :label="$t('subscribe.labellist[7]')" prop="shortEng"
							show-overflow-tooltip></el-table-column>
					</el-table>
				</el-form-item>

				<el-form-item label="" class="formtable" style="width: 100%">
					<el-table :empty-text="$t('header.tableEmpty')" stripe border max-height="350"
						:data="subscribeOrder.GoodsList" style="width: 100%; overflow: auto">
						<el-table-column show-overflow-tooltip>
							<template slot="header" slot-scope="scope">
								<div style="display: flex">
									<!-- <span>{{ $t('subscribe.labellist[8]') }}：</span> overflow: hidden;overflow-y: scroll; height="300"-->
									<!-- <el-button @click="FisShowGoods = true" type="primary" v-show="isEdit == false">{{ $t('subscribe.caozuo[1]') }}</el-button> -->

									<!-- v-show="scope.row == null || scope.row.status === 0 || scope.row.status === 23" -->
									<!-- :disabled="selectPurid == ''" -->

									<el-button @click="FisShowGoods = true" type="primary"
										v-show="scope.row == null || scope.row.status === 0 || scope.row.status === 23">
										{{ $t("subscribe.caozuo[1]") }}
									</el-button>

									<el-button @click="exportAsSampleExcel" type="success"
										icon="el-icon-upload2">{{ $t("subscribe.button[3]") }}</el-button>

									<select-excel :label="$t('subscribe.button[2]')" :on-success="importSuccess"
										:before-upload="importFromSampleExcel"></select-excel>

									<get-goods-list :isShowGoods.sync="FisShowGoods"
										:Stypename.sync="currentPurchaseClass" :purchaseType="purchaseType"
										:arrData="subscribeOrder.GoodsList" :projectId="subscribeOrder.ProjectID"
										@selectGoods="chooseGoods" @closeShowGoods="FisShowGoods = false"
										:getTitle.sync="FitemGetTitle"></get-goods-list>
								</div>
							</template>

							<el-table-column align="center" :label="$t('subscribe.labellist[9]')" prop="Goods.num" show-overflow-tooltip>
								<template slot-scope="scope">
									<span style="cursor: pointer; color: #409EFF; text-decoration: underline;"
										@click="handleCellClick(scope.row)">{{ scope.row.Goods.num }}</span>
								</template>
							</el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[10]')" width="100"
								prop="Goods.name" show-overflow-tooltip></el-table-column>

							<el-table-column :label="$t('subscribe.labellist[36]')" width="100" prop="Goods.localDes"
								show-overflow-tooltip align="center"></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[11]')" prop="count"
								width="150" show-overflow-tooltip>
								<template slot-scope="scope">
									<el-input type="number" v-model="scope.row.count" @blur="inputNum"
										style="width: 100%"
										v-if="subscribeOrder.isComplete === 0 || subscribeOrder.id === 0 || subscribeOrder.status === 0 || subscribeOrder.status === 23"
										min="0"></el-input>
									<el-input type="number" v-model="scope.row.count" disabled style="width: 100%"
										v-else></el-input>
								</template>
							</el-table-column>

							<el-table-column align="center" width="200" :label="$t('subscribe.labellist[19]')"
								prop="requestReason" show-overflow-tooltip required>
								<template slot-scope="scope">
									<el-select v-model="scope.row.requestReason" style="width: 100%"
										v-if="isLook == false">
										<el-option v-for="(itemName, index2) in requestReasonList"
											:key="itemName + index2" :label="itemName.name"
											:value="itemName.name"></el-option>
									</el-select>
									<el-select v-model="scope.row.requestReason" disabled style="width: 100%"
										v-if="isLook == true">
										<el-option v-for="(itemName, index2) in requestReasonList"
											:key="itemName + index2" :label="itemName.name"
											:value="itemName.name"></el-option>
									</el-select>

									<!-- <el-input type="text" v-model="scope.row.requestReason" style="width: 100%;" v-if="isLook == false"></el-input>
									<el-input type="text" v-model="scope.row.requestReason" disabled style="width: 100%;" v-if="isLook == true"></el-input> -->
								</template>
							</el-table-column>

							<el-table-column align="center" width="200" :label="$t('subscribe.labellist[29]')"
								prop="Disagreereason" show-overflow-tooltip required>
								<template slot-scope="scope">
									<!-- <el-select v-model="scope.row.Disagreereason" style="width: 100%;" v-if="auditstate > 1 && isnotify && isLook == false">
									 -->
									<el-select v-model="scope.row.Disagreereason" style="width: 100%"
										v-if="auditstatu > 1 && auditid > 0 && isApprove">
										<el-option v-for="(itemName, index2) in disagreereasonList"
											:key="itemName + index2" :label="itemName.name"
											:value="itemName.name"></el-option>
									</el-select>
									<span v-else>{{ scope.row.Disagreereason }}</span>
								</template>
							</el-table-column>

							<el-table-column align="center" :label="$t('GoodsList.dialog[23]')" prop="AccountNO"
								width="110" show-overflow-tooltip required>
								<template slot-scope="scope">
									<el-select v-model="scope.row.AccountNO" filterable
										@change="val => ACnameChange(scope.row, val)"
										:disabled="isLook == false && isPurchaserOrFinicial == false">
										<el-option v-for="(item, index) in acname" :key="index" :label="item.AccountNO"
											:value="item.AccountNO"></el-option>
									</el-select>
								</template>
							</el-table-column>

							<el-table-column align="center" :label="$t('GoodsList.dialog[27]')" width="120"
								prop="AccountName" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('DepartBudgetBalanceRpt.tableLabel[2]')"
								width="120" prop="BudgetType" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[12]')" prop="Goods.unit"
								show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('GoodsList.dialog[4]')" prop="price"
								show-overflow-tooltip :formatter="tableFormat"
								v-if="UnitPricePermission"></el-table-column>

							<el-table-column align="center" :label="$t('GoodsList.dialog[28]')" prop="totalAmount"
								show-overflow-tooltip :formatter="tableFormat"
								v-if="UnitPricePermission"></el-table-column>

							<el-table-column align="center" width="130" :label="$t('subscribe.labellist[16]')"
								prop="ShipmentDate" :formatter="tableFormat" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" width="130" :label="$t('subscribe.labellist[20]')"
								prop="supplierCode" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[6]')" prop="supplierAbbr"
								show-overflow-tooltip v-if="UnitPricePermission"></el-table-column>

							<el-table-column align="center" width="120" :label="$t('GoodsList.dialog[21]')"
								prop="Goods.NeedInspect" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[7]')" prop="shortEng"
								show-overflow-tooltip></el-table-column>

							<el-table-column>
								<template slot-scope="scope">
									<el-button type="danger" @click="deleteItemRecord(scope.row)" v-if="
                      subscribeOrder.isComplete === 0 ||
                        subscribeOrder.status === 23
                    ">
										{{ $t("subscribe.caozuo[2]") }}
									</el-button>
								</template>
							</el-table-column>
							<!-- scope.row.status === 0 || !isPurchaserOrFinicial -->
						</el-table-column>
					</el-table>
				</el-form-item>

				<el-form-item :label="$t('subscribe.labellist[4]')" prop="explain">
					<el-input type="textarea" v-model="subscribeOrder.explain" style="width: 555px"
						v-if="isLook == false"></el-input>
					<el-input type="textarea" v-model="subscribeOrder.explain" style="width: 555px" disabled
						v-if="isLook == true"></el-input>
				</el-form-item>

				<!-- <el-form-item :label="$t('subscribe.labellist[0]')" v-if="isEdit == true"><el-input v-model="subscribeOrder.optname" disabled></el-input></el-form-item>
				<el-form-item :label="$t('subscribe.labellist[0]')" v-if="isEdit == false"><el-input v-model="base_name" disabled></el-input></el-form-item> -->
				<el-form-item :label="$t('subscribe.labellist[0]')"><el-input v-model="subscribeOrder.optname"
						disabled></el-input></el-form-item>

				<el-form-item :label="$t('subscribe.labellist[1]')">
					<el-select v-model="base_deptname" style="width: 200px; margin-right: 20px" :disabled="
              userData === null ||
                userData.deptData.chooseOtherDept !== 1 ||
                isLook == true ||
                subscribeOrder.isComplete !== 0
            ">
						<el-option style="height: auto; background-color: white" v-model="base_deptnameid">
							<department-tree @selectTreeClass="chooseTreeClass" :isshowTitle="false"></department-tree>
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="" class="auditclass">
					<el-steps :active="active" finish-status="success" style="width: 100%">
						<el-step v-for="(item, index) in auditList" :title="item.name" :key="index"></el-step>
					</el-steps>
				</el-form-item>

				<el-form-item style="display: flex; justify-content: end">
					<el-form-item :label="$t('subscribe.labellist[30]')"
						v-if="isnotify == true && subscribeOrder.status < 2" prop="status">
						<template slot-scope="scope">
							<el-select v-model="auditstatu" :placeholder="$t('SupplierClass.placeholder')"
								style="width: 120px; margin-right: 20px"
								v-if="isnotify == true && subscribeOrder.status == 0">
								<el-option v-for="(item, index) in auditstatulist1" :style="{ color: item.color }"
									:key="index" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</template>
					</el-form-item>

					<el-button type="primary" @click="submitShop()" v-if="isLook == false"
						:disabled="!isEdit && auditList.length <= 0">
						{{ isEdit ? $t("GoodsList.xiugai") : $t("GoodsList.add") }}
					</el-button>
					<el-button type="primary" @click="submitShop1()"
						v-if="isLook == true && isEdit == false">{{ $t("GoodsList.xiugai") }}</el-button>
					<el-button type="primary" @click="audit()"
						v-if="isnotify == true && subscribeOrder.status == 0">{{ $t("audit.buttons[1]") }}</el-button>
					<!-- <el-button @click="resetForm()">重置</el-button> -->
				</el-form-item>
			</el-form>
		</el-dialog>

		<picture-swiper :filesList.sync="currentGoods.picsList" :showPreview.sync="isShowPreview"
			@closeSwiper="FcloseSwiper"></picture-swiper>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import bus from "../bus";
	import wmsApi from "@/request/wmsApi";
	import financeApi from "@/request/financialApi";
	import SupplierSelector from "./SupplierSelector";
	import GetGoodsList from "./GetGoodsList";
	import baseDataApi from "@/request/baseDataApi";
	import personelApi from "@/request/personelApi";
	import SelectExcel from "@/components/common/SelectExcel";
	import xlsxTool from "@/utils/xlsxTool";
	import DepartmentTree from "@/components/common/PersonnelComm/DepartmentTree";
	import baseFunction from "@/utils/baseFunction";
	import PictureSwiper from "@/components/common/PurchasingManagement/PictureSwiper";

	export default {
		name: "AddSubscribeOrder",
		components: {
			SupplierSelector,
			GetGoodsList,
			SelectExcel,
			DepartmentTree,
			PictureSwiper
		},
		props: {
			subscribeOrder: {
				required: true,
				default: () => {},
				type: Object
			},
			isShowSubscribe: {
				required: true,
				default: false,
				type: Boolean
			},
			isEdit: {
				required: false,
				default: false,
				type: Boolean
			},
			isLook: {
				required: false,
				default: false,
				type: Boolean
			},
			purchaseType: {
				required: false,
				default: "Local",
				type: String
			},
			isnotify: {
				required: false,
				default: false,
				type: Boolean
			},
			isApprove: {
				required: false,
				default: false,
				type: Boolean
			},
			auditid: {
				required: false,
				default: 0,
				type: Number
			}
		},
		data() {
			return {
				base_name: "",
				base_deptname: "",
				base_deptnameid: "",
				tableData: [],
				// isEdit:false,
				FisShowSupplier: false, //选择供应商
				FisShowGoods: false, //选择商品
				supplierlaber: "",
				goodslaber: "",
				currvalue: "",
				currencyList: [],
				purchaseClass: [],
				AuditRresults: "",
				active: 1,
				auditList: [],

				selectPurid: "",

				deptBudget: [], // 部门预算

				CurrentBudgetAmount: 0,
				OrderTTLAmount: 0,
				isdisagree: true,
				requestReasonList: [],
				requestKey: "RequestReason",
				disagreereasonList: [],
				UserGroupList: [],
				acname: [],
				haveAccount: {},
				auditstatu: 0,
				disagreeKey: "Return/DisagreeReason",
				isPurchaserOrFinicial: false,
				UnitPricePermission: false,

				FitemGetTitle: this.$t("subscribe.labellist[8]"),

				// 图片预览
				currentGoods: {},
				isShowPreview: false
			};
		},
		mounted() {
			if (this.userData === null || this.userData === undefined) return;

			this.base_name = this.userData.user;

			// this.base_deptname = this.userData.deptname;
			// this.base_deptnameid = this.userData.deptid;
			this.haveAccount = {};

			this.getRequestReasonList();
			this.getCurrencyList();
			this.getPurchaseClass();
			this.getDisagreereasonList();
			// this.getDepartGroupList();
			this.GetAccountingSubjectList();
			// console.log("auditid",auditid);
			this.checkRolePermission();
		},
		methods: {
			open() {
				this.selectPurid = "";
			},

			handleCellClick(row) {
				this.currentGoods = row.Goods;
				if (row.Goods.picsList && row.Goods.picsList.length > 0) {
					this.isShowPreview = true;
				} else {
					this.isShowPreview = false;
					this.$message({
						message: this.$t("GoodsList.msg[10]"),
						type: "warning"
					});
				}
			},

			FcloseSwiper() {
				this.isShowPreview = false;
			},

			checkRolePermission() {
				this.isPurchaserOrFinicial = false;
				this.UnitPricePermission = false;

				this.menuList.forEach(fatherMenu => {
					fatherMenu.childList.forEach(childMenu => {
						if (
							childMenu.keyName === "purchase" ||
							childMenu.keyName === "financialDepartmentbudget" ||
							childMenu.keyName === "financialMonthClosureaccount" ||
							childMenu.keyName === "financialPaymentOrderList" ||
							childMenu.keyName === "financialAccountingSubjectManager"
						) {
							this.isPurchaserOrFinicial = true;
						}
						if (childMenu.keyName === "UnitPricePermission")
							this.UnitPricePermission = true;
					});
				});

				console.log(
					"isPurchaserOrFinicial, UnitPricePermission",
					this.isPurchaserOrFinicial,
					this.UnitPricePermission
				);
			},

			showLog() {
				console.log(this.subscribeOrder.isComplete === 0 && !this.isEdit);
				console.log(
					!this.isPurchaserOrFinicial &&
					this.subscribeOrder.status === 0 &&
					this.subscribeOrder.isComplete === 1
				);
				console.log(
					!this.isPurchaserOrFinicial &&
					this.subscribeOrder.status === 1 &&
					this.subscribeOrder.isComplete === 1
				);
			},

			async GetAccountingSubjectList() {
				this.acname = [];
				let sucRes = await financeApi.GetAccountingSubjectList(
					this.token,
					"",
					1,
					99999
				);
				if (sucRes.resultCode === 0) {
					this.acname = sucRes.data;
				}
			},

			async getRequestReasonList() {
				this.requestReasonList = [];
				let sucRes = await baseDataApi.GetBaseDataList(
					this.token,
					this.requestKey,
					1,
					99999
				);
				if (sucRes.resultCode === 0) {
					this.requestReasonList = sucRes.data;
				}
			},

			async getDisagreereasonList() {
				this.disagreereasonList = [];
				let sucRes = await baseDataApi.GetBaseDataList(
					this.token,
					this.disagreeKey,
					1,
					99999
				);
				if (sucRes.resultCode === 0) {
					this.disagreereasonList = sucRes.data;
				}
			},

			async getDepartGroupList(deptid) {
				this.UserGroupList = [];

				let sucRes = await personelApi.GetDepartGroupList(
					this.token,
					deptid,
					"1"
				);
				if (sucRes.resultCode === 0) {
					this.UserGroupList = sucRes.data;
				}
			},

			chooseTreeClass(data) {
				this.base_deptname = data.name;
				this.base_deptnameid = data.id;
				this.subscribeOrder.deptname = data.name;
				this.subscribeOrder.deptid = data.id;
				this.getDepartGroupList(this.base_deptnameid);
				// this.GetAccountNOTemplate();
			},

			async importFromSampleExcel(file) {
				var that = this;
				if (!that.subscribeOrder.purid || that.subscribeOrder.purid === 0) {
					that.$message({
						message: that.$t("subscribe.errmsg[4]"),
						type: "warning"
					});
					return;
				}

				let loading = that.$loading(that.loadingOption);

				xlsxTool.onImportExcel(file).then(async result => {
					console.log(result);
					let errMsg = "";
					if (!that.subscribeOrder.GoodsList) that.subscribeOrder.GoodsList = [];

					for (let i = 0; i < result.length; i++) {
						// 判断申购原因在系统存不存在
						if (
							result[i].requestReason &&
							result[i].requestReason !== null &&
							result[i].requestReason !== undefined
						) {
							let findReasonObj = this.requestReasonList.find(match => {
								return match.name === result[i].requestReason;
							});
							console.log(findReasonObj);
							if (findReasonObj === null || findReasonObj === undefined) {
								this.$message({
									message: result[i].itemNum +
										`[${result[i].requestReason}] ${this.$t(
                    "notMatchRequestReason"
                  )}`,
									type: "warning"
								});
								continue;
							}
						}

						this.acname.forEach(groupObj => {
							if (groupObj.AccountNO == result[i].AccountNO) {
								result[i].AccountNO = groupObj.AccountNO;
								result[i].AccountName = groupObj.AccountName;
								result[i].BudgetType = groupObj.BudgetType;
							}
						});

						// let findObj = that.subscribeOrder.GoodsList.find(match => match.num && match.num === result[i].itemNum);
						let findObj = null;
						for (let j = 0; j < that.subscribeOrder.GoodsList.length; j++) {
							if (
								that.subscribeOrder.GoodsList[j].Goods &&
								that.subscribeOrder.GoodsList[j].Goods.num === result[i].itemNum
							) {
								findObj = that.subscribeOrder.GoodsList[j];
								break;
							}
						}
						if (findObj && result[i].count) {
							findObj.count = result[i].count;
							findObj.AccountNO = result[i].AccountNO;
							findObj.AccountName = result[i].AccountName;
							findObj.BudgetType = result[i].BudgetType;
						} else {
							let sucRes = await wmsApi.GetGoodsInfo(
								that.token,
								0,
								"",
								result[i].itemNum
							);
							if (sucRes.resultCode === 0) {
								if (sucRes.data.classid !== that.subscribeOrder.purid) {
									errMsg += `${sucRes.data.name} belongs to ${sucRes.data.classCode};\n`;
									continue;
								}

								if (
									sucRes.data.purchaseType !== that.subscribeOrder.purchaseType
								) {
									errMsg +=
										`${sucRes.data.name} purchase type is ${sucRes.data.purchaseType};\n`;
									continue;
								}

								let priceObj = sucRes.data.priceList.find(
									match => match.isUsed === 1
								);
								that.subscribeOrder.GoodsList.push({
									supplierCode: priceObj ? priceObj.custcode : "",
									supplierAbbr: priceObj ? priceObj.custabbre : "",
									count: result[i].count,
									requestReason: result[i].requestReason,
									disagreereason: result[i].Disagreereason,
									price: sucRes.data.price,
									totalAmount: 0,
									Goods: sucRes.data,
									AccountNO: result[i].AccountNO,
									AccountName: result[i].AccountName,
									BudgetType: result[i].BudgetType
								});
							} else {
								errMsg += sucRes.errMsg;
							}
						}
					}

					// that.GetAccountNOTemplate();
					await that.autoFillAccountNO();

					loading.close();
					that.inputNum();
					if (errMsg) {
						that
							.$confirm(errMsg, that.$t("header.tishi"), {
								showCancelButton: false,
								type: "warning"
							})
							.then(() => {
								that.auditList = [];
							})
							.catch(() => {});
					}
				});
			},

			exportAsSampleExcel() {
				this.showLog();
				if (this.subscribeOrder.GoodsList.length > 0) {
					let tmpArr = [];
					this.subscribeOrder.GoodsList.forEach(item => {
						let priceObj = item.Goods.priceList.find(match => match.isUsed === 1);
						let tmpObj = {
							itemNum: item.Goods.num,
							itemName: item.Goods.name,
							count: item.count,
							unit: item.unit,
							price: item.Goods.price,
							// totalAmount: item.count * item.Goods.price,
							totalAmount: item.totalAmount,
							classCode: item.Goods.classCode,
							supplierCode: item.supplierCode,
							supplierAbbr: item.supplierAbbr,
							purchaseType: item.Goods.purchaseType,
							AccountNO: item.AccountNO,
							AccountName: item.AccountName,
							currency: priceObj ? priceObj.currency : "",
							requestReason: item.requestReason,
							disagreereason: item.Disagreereason
						};
						tmpArr.push(tmpObj);
					});
					xlsxTool.exportFile(tmpArr, "purchaseRequestSample.xlsx");
				} else {
					this.$message({
						message: this.$t("subscribe.errmsg[3]"),
						type: "warning"
					});
				}
			},

			importSuccess() {},

			async getPurchaseClass() {
				this.purchaseClass = [];
				let sucRes = await baseDataApi.GetPurchaseClass(this.token);
				if (sucRes.resultCode === 0) {
					this.purchaseClass = sucRes.data;
				}
			},

			async getCurrencyList() {
				this.currencyList = [];
				let sucRes = await baseDataApi.GetCurrencyList();
				if (sucRes.resultCode === 0) {
					this.currencyList = sucRes.data;
				}
			},

			async inputNum() {
				var detailList = [];
				this.auditList = [];
				this.deptBudget = [];
				// console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
				// console.log('````````````````````````````````',this.subscribeOrder.GoodsList);
				this.subscribeOrder.GoodsList.forEach(detailobj => {
					// console.log('@@@@@@@@@@@@@@@@@@@@@@@@@',detailobj);
					// console.log('########################',detailobj.count);
					(detailobj.totalAmount =
						detailobj.Goods.price *
						(detailobj.count === undefined ? 0 : detailobj.count)),
					detailList.push({
						goodsid: detailobj.Goods.id,
						count: detailobj.count === undefined ? 0 : detailobj.count,
						price: detailobj.Goods.price,
						unit: detailobj.Goods.unit,
						AccountNO: detailobj.AccountNO,
						AccountName: detailobj.AccountName,
						BudgetType: detailobj.BudgetType === undefined ? "" : detailobj.BudgetType
					});
				});
				this.subscribeOrder.detailList = detailList;
				this.subscribeOrder.deptid = this.base_deptnameid;
				// console.log('subscribeOrder', this.subscribeOrder);

				let submitGoodsRes = await wmsApi.GetApprovalList(
					this.token,
					this.subscribeOrder
				);
				// console.log(submitGoodsRes);

				if (submitGoodsRes.resultCode === 0) {
					if (submitGoodsRes.data.budgetAmount != 0) {
						submitGoodsRes.data.budgetAmount = submitGoodsRes.data.budgetAmount.toFixed(
							2
						);
					}

					if (submitGoodsRes.data.budgetAmount) {
						submitGoodsRes.data.budgetAmount += "";
						if (!submitGoodsRes.data.budgetAmount.includes("."))
							submitGoodsRes.data.budgetAmount += ".";
						submitGoodsRes.data.budgetAmount = submitGoodsRes.data.budgetAmount
							.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
								return $1 + ",";
							})
							.replace(/\.$/, "");
					}

					if (submitGoodsRes.data.totalAmount) {
						submitGoodsRes.data.totalAmount += "";
						if (!submitGoodsRes.data.totalAmount.includes("."))
							submitGoodsRes.data.totalAmount += ".";
						submitGoodsRes.data.totalAmount = submitGoodsRes.data.totalAmount
							.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
								return $1 + ",";
							})
							.replace(/\.$/, "");
					}

					submitGoodsRes.data.budgetList.forEach((infoobj, index) => {
						// var infoobj.redtext = false;

						if (infoobj.withoutAfterAmount < 0) {
							infoobj.redtext = true;
						} else {
							infoobj.redtext = false;
						}

						if (infoobj.withoutAfterAmount != 0) {
							infoobj.withoutAfterAmount = infoobj.withoutAfterAmount.toFixed(2);
						}

						if (infoobj.currentBudgetAmount != 0) {
							infoobj.currentBudgetAmount = infoobj.currentBudgetAmount.toFixed(
								2
							);
						}

						if (infoobj.budget) {
							infoobj.budget += "";
							if (!infoobj.budget.includes(".")) infoobj.budget += ".";
							infoobj.budget = infoobj.budget
								.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
									return $1 + ",";
								})
								.replace(/\.$/, "");
						}

						if (infoobj.totalPurAmount) {
							infoobj.totalPurAmount += "";
							if (!infoobj.totalPurAmount.includes("."))
								infoobj.totalPurAmount += ".";
							infoobj.totalPurAmount = infoobj.totalPurAmount
								.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
									return $1 + ",";
								})
								.replace(/\.$/, "");
						}

						if (infoobj.withoutAfterAmount) {
							infoobj.withoutAfterAmount += "";
							if (!infoobj.withoutAfterAmount.includes("."))
								infoobj.withoutAfterAmount += ".";
							infoobj.withoutAfterAmount = infoobj.withoutAfterAmount
								.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
									return $1 + ",";
								})
								.replace(/\.$/, "");
						}

						if (infoobj.currentBudgetAmount) {
							infoobj.currentBudgetAmount += "";
							if (!infoobj.currentBudgetAmount.includes("."))
								infoobj.currentBudgetAmount += ".";
							infoobj.currentBudgetAmount = infoobj.currentBudgetAmount
								.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
									return $1 + ",";
								})
								.replace(/\.$/, "");
						}

						if (infoobj.ApprovedAmount) {
							infoobj.ApprovedAmount += "";
							if (!infoobj.ApprovedAmount.includes("."))
								infoobj.ApprovedAmount += ".";
							infoobj.ApprovedAmount = infoobj.ApprovedAmount.replace(
								/(\d)(?=(\d{3})+\.)/g,
								($0, $1) => {
									return $1 + ",";
								}
							).replace(/\.$/, "");
						}
					});

					this.deptBudget = submitGoodsRes.data.budgetList;
					// console.log(this.deptBudget);

					this.CurrentBudgetAmount = submitGoodsRes.data.budgetAmount;
					this.OrderTTLAmount = submitGoodsRes.data.totalAmount;

					this.auditList = [];
					this.auditList.unshift({
						name: this.$t("subscribe.button[4]")
					});
					submitGoodsRes.data.checkQueue.forEach((item, index) => {
						this.auditList.push(item);
					});
					// this.auditList = submitGoodsRes.data
					this.auditList.push({
						name: this.$t("subscribe.button[5]")
					});

					submitGoodsRes.data.budgetList.forEach((listobj, listindex) => {
						this.getDepartBudgetInfo(listobj, listindex);
					});
				} else {
					this.$confirm(submitGoodsRes.errMsg, this.$t("header.tishi"), {
							showCancelButton: false,
							type: "warning"
						})
						.then(() => {
							this.auditList = [];
						})
						.catch(() => {});
				}
			},

			async autoFillAccountNO() {
				try {
					if (
						this.subscribeOrder.deptid &&
						this.subscribeOrder.purid &&
						this.subscribeOrder.GroupID
					) {
						this.subscribeOrder.GoodsList.forEach(async item => {
							console.log("item->", item);
							if (!item.AccountNO) {
								let accSucRes = await financeApi.GetAccountNOTemplate(
									this.token,
									this.subscribeOrder.purid,
									this.subscribeOrder.deptid,
									this.subscribeOrder.GroupID,
									item.Goods.id
								);
								if (accSucRes.resultCode === 0) {
									item.AccountNO = accSucRes.data.AccountNO;
									item.AccountName = accSucRes.data.AccountName;
									item.BudgetType = accSucRes.data.BudgetType;
								} else {
									item.AccountNO = "";
									item.AccountName = "";
									item.BudgetType = "";
								}
							}
						});
					}
				} catch (ex) {
					console.warn(ex);
				}
			},

			chooseGoods(data) {
				this.FisShowGoods = false;
				this.goodslaber = data;

				console.log("data---------查看父组件有没有接收到这个值", data);

				console.log("subscribeOrder---------find1", this.subscribeOrder);
				// setTimeout(()=>{
				if (this.subscribeOrder.GoodsList.length > 0) {
					let dataLength = data.length;
					while (dataLength > 0) {
						let existsObj = this.subscribeOrder.GoodsList.find(
							match => match.Goods.id === data[dataLength - 1].id
						);
						if (existsObj) {
							data.splice(dataLength - 1, 1);
						}
						--dataLength;
					}
					console.log("data---------find12", data);

					data.forEach(async (dataobj, index) => {
						console.log("dataobj---------find2", dataobj);
						let priceObj = dataobj.priceList.find(match => match.isUsed === 1);
						// console.log(priceObj);
						this.subscribeOrder.GoodsList.push({
							shortEng: priceObj != null ? priceObj.currency : "",
							supplierCode: priceObj != null ? priceObj.custcode : "",
							supplierAbbr: priceObj != null ? priceObj.custabbre : "",
							requestReason: "",
							Disagreereason: "",
							count: 0,
							unit: dataobj.unit,
							price: dataobj.price,
							totalAmount: 0,
							Goods: dataobj,
							AccountNO: "",
							AccountName: ""
						});
					});
				} else {
					data.forEach((dataobj, index) => {
						// 出错的原因在，没有返回priceList，因此无法选择供应商报价
						let priceObj = dataobj.priceList.find(match => match.isUsed === 1);
						// console.log(priceObj);
						this.subscribeOrder.GoodsList.push({
							shortEng: priceObj != null ? priceObj.currency : "",
							supplierCode: priceObj != null ? priceObj.custcode : "",
							supplierAbbr: priceObj != null ? priceObj.custabbre : "",
							requestReason: "",
							Disagreereason: "",
							count: 0,
							unit: dataobj.unit,
							price: dataobj.price,
							totalAmount: 0,
							Goods: dataobj,
							AccountNO: "",
							AccountName: ""
						});
					});
				}

				this.syncGoodsList();

				this.autoFillAccountNO();
				// },1000)
			},

			chooseSupplier(laber) {
				console.log("laber", laber);
				this.supplierlaber = laber;
				this.subscribeOrder.custid = laber.id;
				this.subscribeOrder.custname = laber.name;
				this.FisShowSupplier = false;
			},

			currencyChange(value) {
				// console.log(value);
				let findObj = this.currencyList.find(match => match.id === value);
				// console.log(findObj);
				// this.subscribeOrder.currencyid = findObj.id;
				this.subscribeOrder.shortEng = findObj.ShortEng;
				console.log(this.subscribeOrder);
				this.$forceUpdate();
			},

			purchaseCategoryChange() {
				this.selectPurid = this.subscribeOrder.purid;
				this.purchaseClass.forEach(purobj => {
					if (purobj.id == this.subscribeOrder.purid) {
						this.subscribeOrder.purid = purobj.id;
						this.subscribeOrder.purclass = purobj.purgoods_En;
					}
				});
				this.subscribeOrder.GoodsList = [];
				console.log(this.subscribeOrder.purid, this.subscribeOrder.purclass);

				this.getDepartBudgetInfo();
				// this.GetAccountNOTemplate();
			},

			laborGroupChange(e) {
				this.UserGroupList.forEach(groupobj => {
					if (groupobj.id == e) {
						this.subscribeOrder.GroupID = groupobj.id;
						this.subscribeOrder.GroupName = groupobj.groupName;
					}
				});
				// this.GetAccountNOTemplate();
				// console.log(e);
				// this.subscribeOrder = this.subscribeOrder;
				console.log(this.subscribeOrder);
			},

			ACnameChange(row, e) {
				console.log("ACnameChange", row, e);
				this.acname.forEach(groupobj => {
					if (groupobj.AccountNO == e) {
						// this.subscribeOrder.AccountNO = groupobj.AccountNO;
						// this.subscribeOrder.AccountName = groupobj.AccountName;
						// if (JSON.stringify(this.haveAccount) != '{}') {
						// 	this.haveAccount.AccountNO = groupobj.AccountNO;
						// 	this.haveAccount.AccountName = groupobj.AccountName;
						// }
						row.AccountNO = groupobj.AccountNO;
						row.AccountName = groupobj.AccountName;
						row.BudgetType = groupobj.BudgetType;
					}
				});
				this.inputNum();
				// console.log(e);
				console.log(row);
			},

			// async GetAccountNOTemplate() {
			// 	this.haveAccount = {};

			// 	if (
			// 		this.subscribeOrder.purid &&
			// 		this.subscribeOrder.purid !== 0 &&
			// 		this.subscribeOrder.GroupID &&
			// 		this.subscribeOrder.GroupID != '' &&
			// 		this.subscribeOrder.deptid != ''
			// 	) {
			// 		let sucRes = await financeApi.GetAccountNOTemplate(this.token, this.subscribeOrder.purid, this.subscribeOrder.deptid, this.subscribeOrder.GroupID);
			// 		// console.log(sucRes);
			// 		if (sucRes.resultCode === 0) {
			// 			this.haveAccount = sucRes.data;
			// 			this.$set(this.subscribeOrder, 'AccountNO', sucRes.data.AccountNO);
			// 			this.$set(this.subscribeOrder, 'AccountName', sucRes.data.AccountName);
			// 			this.$set(this.subscribeOrder, 'BudgetType', sucRes.data.BudgetType);
			// 		} else {
			// 			this.haveAccount = {};
			// 			this.$set(this.subscribeOrder, 'AccountNO', '');
			// 			this.$set(this.subscribeOrder, 'AccountName', '');
			// 			this.$set(this.subscribeOrder, 'BudgetType', '');
			// 		}

			// 		console.log('this.subscribeOrder', this.subscribeOrder);
			// 	}
			// },

			async getDepartBudgetInfo(budget, budgetindex) {
				let sucRes = await financeApi.GetDepartBudgetInfo(
					this.token,
					this.subscribeOrder.deptid,
					this.subscribeOrder.applydt,
					this.subscribeOrder.id,
					budget.BudgetType
				);

				if (sucRes.resultCode === 0) {
					// console.log('getDepartBudgetInfo', sucRes.data);
					var redtext = false;
					if (sucRes.data.withoutAfterAmount < 0) {
						redtext = true;
					} else {
						redtext = false;
					}

					if (sucRes.data.withoutAfterAmount != 0) {
						sucRes.data.withoutAfterAmount = sucRes.data.withoutAfterAmount.toFixed(
							2
						);
					}

					// if (sucRes.data.budget) {
					// 	sucRes.data.budget += '';
					// 	if (!sucRes.data.budget.includes('.')) sucRes.data.budget += '.';
					// 	sucRes.data.budget = sucRes.data.budget
					// 		.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
					// 			return $1 + ',';
					// 		})
					// 		.replace(/\.$/, '');
					// }

					if (sucRes.data.withoutAfterAmount) {
						sucRes.data.withoutAfterAmount += "";
						if (!sucRes.data.withoutAfterAmount.includes("."))
							sucRes.data.withoutAfterAmount += ".";
						sucRes.data.withoutAfterAmount = sucRes.data.withoutAfterAmount
							.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
								return $1 + ",";
							})
							.replace(/\.$/, "");
					}

					if (sucRes.data.totalPurAmount) {
						sucRes.data.totalPurAmount += "";
						if (!sucRes.data.totalPurAmount.includes("."))
							sucRes.data.totalPurAmount += ".";
						sucRes.data.totalPurAmount = sucRes.data.totalPurAmount
							.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
								return $1 + ",";
							})
							.replace(/\.$/, "");
					}

					// if (sucRes.data.ApprovedAmount) {
					// 	sucRes.data.ApprovedAmount += '';
					// 	if (!sucRes.data.ApprovedAmount.includes('.')) sucRes.data.ApprovedAmount += '.';
					// 	sucRes.data.ApprovedAmount = sucRes.data.ApprovedAmount.replace(/(\d)(?=(\d{3})+\.)/g, ($0,
					// 		$1) => {
					// 		return $1 + ',';
					// 	}).replace(/\.$/, '');
					// }

					this.deptBudget[budgetindex].withoutAfterAmount =
						sucRes.data.withoutAfterAmount;
					// this.deptBudget[budgetindex].ApprovedAmount = sucRes.data.ApprovedAmount;
					this.deptBudget[budgetindex].totalPurAmount =
						sucRes.data.totalPurAmount;
					this.deptBudget[budgetindex].redtext = redtext;
				} else {
					this.$message({
						message: this.$t("subscribe.errmsg[5]"),
						type: "error"
					});
				}
			},

			deleteItemRecord(e) {
				console.log(e);
				if (this.subscribeOrder.id !== 0) {
					this.$confirm(this.$t("subscribe.errmsg[7]"), this.$t("header.tishi"), {
							showCancelButton: false,
							type: "warning"
						})
						.then(async () => {
							let delRes = await wmsApi.DeletePurchaseRequestionItem(
								this.token,
								e.id
							);
							if (delRes.resultCode === 0) {
								this.$message({
									message: delRes.errMsg,
									type: "success"
								});
								this.subscribeOrder.GoodsList.forEach((listobj, index) => {
									if (listobj.Goods.id == e.Goods.id) {
										this.subscribeOrder.GoodsList.splice(index, 1);
									}
								});
							} else {
								this.$message({
									message: delRes.errMsg,
									type: "warning"
								});
							}
						})
						.catch(() => {});
				} else {
					this.subscribeOrder.GoodsList.forEach((listobj, index) => {
						if (listobj.Goods.id == e.Goods.id) {
							this.subscribeOrder.GoodsList.splice(index, 1);
						}
					});
				}
			},

			async submitShop() {
				// console.log('tableData',this.tableData);
				if (
					this.subscribeOrder.currencyid == "" ||
					this.subscribeOrder.currencyid == null
				) {
					this.$message({
						message: this.$t("subscribe.labellist[7]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (
					this.subscribeOrder.purid == "" ||
					this.subscribeOrder.purid == null
				) {
					this.$message({
						message: this.$t("GoodsList.dialog[15]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (
					this.subscribeOrder.GoodsList == "" ||
					this.subscribeOrder.GoodsList == null ||
					this.subscribeOrder.GoodsList == [] ||
					this.subscribeOrder.GoodsList.length == 0
				) {
					this.$message({
						message: this.$t("subscribe.labellist[8]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (
					this.subscribeOrder.GroupID == "" ||
					this.subscribeOrder.GroupID == null
				) {
					this.$message({
						message: this.$t("subscribe.labellist[32]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				var detailList = [];
				var iscount = true;
				let requestReasonSuccess = true;

				this.subscribeOrder.GoodsList.forEach(detailobj => {
					if (detailobj.count === undefined) {
						iscount = false;
					} else {
						iscount = true;
					}
					if (detailobj.requestReason === "") requestReasonSuccess = false;

					detailList.push({
						goodsid: detailobj.Goods.id,
						count: detailobj.count,
						price: detailobj.Goods.price,
						unit: detailobj.Goods.unit,
						requestReason: detailobj.requestReason,
						disagreereason: detailobj.Disagreereason,
						AccountNO: detailobj.AccountNO,
						AccountName: detailobj.AccountName,
						BudgetType: detailobj.BudgetType
					});
				});

				if (iscount == false) {
					this.$message({
						message: this.$t("subscribe.labellist[11]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (!requestReasonSuccess) {
					this.$message({
						message: this.$t("subscribe.errmsg[6]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (this.isEdit == false) {
					this.subscribeOrder.id = 0;
					delete this.subscribeOrder.GoodsList;
				}

				this.subscribeOrder.detailList = detailList;

				if (this.isEdit == true) {
					this.subscribeOrder.GoodsList.forEach(detailobj => {
						delete detailobj.Goods;
					});
				}
				// this.subscribeOrder.deptid = this.base_deptnameid;
				// console.log('subscribeOrder', this.subscribeOrder);

				/*if (this.subscribeOrder.AccountNO == '') {
						} else {
							console.log('this.haveAccount', this.haveAccount);
							if (JSON.stringify(this.haveAccount) != '{}') {
								let acountRes = await financeApi.CreateOrEditAccountNOTemplate(this.token, this.haveAccount);
								console.log(acountRes);
							} else {
								var acountdata = {};

								acountdata = {
									id: 0,
									purid: this.subscribeOrder.purid,
									deptid: this.subscribeOrder.deptid,
									userGroupId: this.subscribeOrder.GroupID,
									AccountNO: this.subscribeOrder.AccountNO,
									AccountName: this.subscribeOrder.AccountName
								};
								let acountRes = await financeApi.CreateOrEditAccountNOTemplate(this.token, acountdata);
								console.log(acountRes);
							}
						}*/

				let submitGoodsRes = await wmsApi.CreateOrEditSubscribe(
					this.token,
					this.subscribeOrder
				);
				// console.log(submitGoodsRes);

				if (submitGoodsRes.resultCode === 0) {
					this.$message({
						message: (this.isEdit ?
							this.$t("GoodsList.xiugai") :
							this.$t("GoodsList.add")) + this.$t("GoodsList.msg[0]"),
						type: "success"
					});
					this.subscribeOrder = {};
					this.supplierlaber = "";
					this.currvalue = "";
					this.deptBudget = [];
					this.CurrentBudgetAmount = 0;
					this.OrderTTLAmount = 0;
					this.$emit("closeSubscribe");
				} else {
					this.$confirm(
							submitGoodsRes.errMsg,
							(this.isEdit ?
								this.$t("GoodsList.xiugai") :
								this.$t("GoodsList.add")) + this.$t("GoodsList.msg[1]"), {
								showCancelButton: false,
								type: "warning"
							}
						)
						.then(() => {
							// this.subscribeOrder = {};
							// this.supplierlaber = '';
							// this.currvalue = '';
							// this.CurrentBudgetAmount = 0;
							// this.OrderTTLAmount = 0;
							// this.$emit('closeSubscribe');
						})
						.catch(() => {});
				}
			},

			async submitShop1() {
				// console.log('tableData',this.tableData);
				if (
					this.subscribeOrder.currencyid == "" ||
					this.subscribeOrder.currencyid == null
				) {
					this.$message({
						message: this.$t("subscribe.labellist[7]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (
					this.subscribeOrder.purid == "" ||
					this.subscribeOrder.purid == null
				) {
					this.$message({
						message: this.$t("GoodsList.dialog[15]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (
					this.subscribeOrder.GoodsList == "" ||
					this.subscribeOrder.GoodsList == null ||
					this.subscribeOrder.GoodsList == [] ||
					this.subscribeOrder.GoodsList.length == 0
				) {
					this.$message({
						message: this.$t("subscribe.labellist[8]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (
					this.subscribeOrder.GroupID == "" ||
					this.subscribeOrder.GroupID == null
				) {
					this.$message({
						message: this.$t("subscribe.labellist[32]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				var detailList = [];
				var iscount = true;
				let requestReasonSuccess = true;

				this.subscribeOrder.GoodsList.forEach(detailobj => {
					if (detailobj.count === undefined) {
						iscount = false;
					} else {
						iscount = true;
					}
					if (detailobj.requestReason === "") requestReasonSuccess = false;

					detailList.push({
						goodsid: detailobj.Goods.id,
						count: detailobj.count,
						price: detailobj.Goods.price,
						unit: detailobj.Goods.unit,
						requestReason: detailobj.requestReason,
						disagreereason: detailobj.Disagreereason,
						AccountNO: detailobj.AccountNO,
						AccountName: detailobj.AccountName,
						BudgetType: detailobj.BudgetType
					});
				});

				if (iscount == false) {
					this.$message({
						message: this.$t("subscribe.labellist[11]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				if (!requestReasonSuccess) {
					this.$message({
						message: this.$t("subscribe.errmsg[6]") + " " + this.$t("depart.msg[1]"),
						type: "warning"
					});
					return;
				}

				this.subscribeOrder.detailList = detailList;

				this.subscribeOrder.GoodsList.forEach(detailobj => {
					delete detailobj.Goods;
				});

				this.subscribeOrder.deptid = this.base_deptnameid;
				// console.log('subscribeOrder', this.subscribeOrder);

				/*if (this.subscribeOrder.AccountNO == '') {} else {
							console.log('this.haveAccount', this.haveAccount);
							if (JSON.stringify(this.haveAccount) != '{}') {
								let acountRes = await financeApi.CreateOrEditAccountNOTemplate(this.token, this.haveAccount);
								console.log(acountRes);
							} else {
								var acountdata = {};

								acountdata = {
									id: 0,
									purid: this.subscribeOrder.purid,
									deptid: this.subscribeOrder.deptid,
									userGroupId: this.subscribeOrder.GroupID,
									AccountNO: this.subscribeOrder.AccountNO,
									AccountName: this.subscribeOrder.AccountName
								};
								let acountRes = await financeApi.CreateOrEditAccountNOTemplate(this.token, acountdata);
								console.log(acountRes);
							}
						}*/

				// let submitGoodsRes = await wmsApi.CreateOrEditSubscribe(this.token, this.subscribeOrder);
				let submitGoodsRes = await wmsApi.EditSubscribe(
					this.token,
					this.subscribeOrder
				);
				// console.log(submitGoodsRes);

				if (submitGoodsRes.resultCode === 0) {
					this.$message({
						message: this.$t("GoodsList.xiugai") + this.$t("GoodsList.msg[0]"),
						type: "success"
					});
					this.subscribeOrder = {};
					this.supplierlaber = "";
					this.currvalue = "";
					this.deptBudget = [];
					this.CurrentBudgetAmount = 0;
					this.OrderTTLAmount = 0;
					this.$emit("closeSubscribe");
				} else {
					this.$confirm(
							submitGoodsRes.errMsg,
							this.$t("GoodsList.xiugai") + this.$t("GoodsList.msg[1]"), {
								showCancelButton: false,
								type: "warning"
							}
						)
						.then(() => {
							// this.subscribeOrder = {};
							// this.supplierlaber = '';
							// this.currvalue = '';
							// this.CurrentBudgetAmount = 0;
							// this.OrderTTLAmount = 0;
							// this.$emit('closeSubscribe');
						})
						.catch(() => {});
				}
			},

			resetForm() {
				this.supplierlaber = "";
				this.subscribeOrder = {};
				this.currvalue = "";
			},

			subscribeClose(done) {
				this.$confirm(this.$t("header.confirm"), this.$t("header.tishi"), {
						confirmButtonText: this.$t("header.confirmButtonText"),
						cancelButtonText: this.$t("header.cancelButtonText"),
						type: "warning"
					})
					.then(() => {
						this.$emit("closeSubscribe");
						this.CurrentBudgetAmount = 0;
						this.OrderTTLAmount = 0;
						this.supplierlaber = "";
						// this.subscribeOrder = {};
						this.currvalue = "";
						this.deptBudget = [];
						this.auditList = [];
						this.auditstatu = 0;
						done();
					})
					.catch(() => {});
			},

			syncGoodsList() {
				if (!this.subscribeOrder.detailList) this.subscribeOrder.detailList = [];
				this.subscribeOrder.GoodsList.sort((a, b) => a.Goods.id < b.Goods.id);
				// console.log('sort->', this.subscribeOrder.GoodsList);
				let dataLength = this.subscribeOrder.GoodsList.length;
				while (dataLength > 0) {
					let tmpObj = this.subscribeOrder.detailList.find(
						match =>
						match.goodsid ===
						this.subscribeOrder.GoodsList[dataLength - 1].Goods.id
					);
					let priceObj = this.subscribeOrder.GoodsList[
						dataLength - 1
					].Goods.priceList.find(match => match.isUsed == 1);
					if (!tmpObj) {
						tmpObj = {
							num: this.subscribeOrder.GoodsList[dataLength - 1].Goods.num,
							name: this.subscribeOrder.GoodsList[dataLength - 1].Goods.name,
							goodsid: this.subscribeOrder.GoodsList[dataLength - 1].Goods.id,
							count: this.subscribeOrder.GoodsList[dataLength - 1].Goods.stock,
							price: this.subscribeOrder.GoodsList[dataLength - 1].Goods.price,
							unit: this.subscribeOrder.GoodsList[dataLength - 1].Goods.unit,
							supplierCode: priceObj != null ? priceObj.custcode : "",
							supplierAbbr: priceObj != null ? priceObj.custabbre : ""
						};
						this.subscribeOrder.detailList.push(tmpObj);
					}
					--dataLength;
				}
				this.subscribeOrder.detailList.sort((a, b) => a.goodsid < b.goodsid);
				// console.log(this.subscribeOrder.detailList);
			},

			tableFormat(row, column, cellValue, index) {
				if (column.label == this.$t("GoodsList.dialog[4]")) {
					if (row.price) {
						row.price += "";
						if (!row.price.includes(".")) row.price += ".";
						return row.price
							.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
								return $1 + ",";
							})
							.replace(/\.$/, "");
					}
				}

				if (column.label == this.$t("GoodsList.dialog[28]")) {
					if (row.totalAmount) {
						row.totalAmount += "";
						if (!row.totalAmount.includes(".")) row.totalAmount += ".";
						return row.totalAmount
							.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
								return $1 + ",";
							})
							.replace(/\.$/, "");
					}
				}

				if (column.label == this.$t("subscribe.labellist[16]")) {
					if (row.ShipmentDate) {
						if (row.ShipmentDate != "") {
							row.ShipmentDate = baseFunction.formatterDate(row.ShipmentDate);
							return row.ShipmentDate;
						}
					}
				}

				return cellValue;
			},

			async audit() {
				let appid = [];
				appid.push(this.auditid);

				if (this.auditstatu != 0 && this.auditstatu != 1) {
					// console.log('subscribeOrder', this.subscribeOrder);

					var detailList = [];
					var iscount = true;
					let requestReasonSuccess = true;

					this.subscribeOrder.GoodsList.forEach(detailobj => {
						if (detailobj.count === undefined) {
							iscount = false;
						} else {
							iscount = true;
						}
						if (detailobj.requestReason === "") requestReasonSuccess = false;

						detailList.push({
							goodsid: detailobj.Goods.id,
							count: detailobj.count,
							price: detailobj.Goods.price,
							unit: detailobj.Goods.unit,
							requestReason: detailobj.requestReason,
							disagreereason: detailobj.Disagreereason,
							AccountNO: detailobj.AccountNO,
							AccountName: detailobj.AccountName,
							BudgetType: detailobj.BudgetType
						});
					});

					if (iscount == false) {
						this.$message({
							message: this.$t("subscribe.labellist[11]") +
								" " +
								this.$t("depart.msg[1]"),
							type: "warning"
						});
						return;
					}

					if (!requestReasonSuccess) {
						this.$message({
							message: this.$t("subscribe.errmsg[6]") + " " + this.$t("depart.msg[1]"),
							type: "warning"
						});
						return;
					}

					this.subscribeOrder.detailList = detailList;

					let submitEditSubscribe = await wmsApi.CreateOrEditSubscribe(
						this.token,
						this.subscribeOrder
					);
					// console.log('submitEditSubscribe', submitEditSubscribe);
				} else {
					this.subscribeOrder.Disagreereason = "";
				}

				let submitRes = await wmsApi.ApprovalRequest(
					this.token,
					appid,
					"",
					"",
					this.auditstatu
				);
				console.log("submitRes: ", submitRes);

				if (submitRes.resultCode === 0) {
					this.$message({
						message: this.$t("GoodsList.submitBtn") + " " + this.$t("GoodsList.msg[0]"),
						type: "success"
					});
					this.CurrentBudgetAmount = 0;
					this.OrderTTLAmount = 0;
					this.$emit("closeSubscribe");
				} else {
					this.$confirm(submitRes.errMsg, this.$t("header.tishi"), {
						confirmButtonText: this.$t("header.confirmButtonText"),
						cancelButtonText: this.$t("header.cancelButtonText"),
						type: "warning"
					});
				}
			}
		},
		computed: mapState({
			userData: state => state.user.userData,
			token: state => state.user.token,
			menuList: state => state.user.menuList,
			loadingOption: state => state.system.loadingOption,
			currentPurchaseClass() {
				let purchaseModel = this.purchaseClass.find(
					match => match.id === this.subscribeOrder.purid
				);
				return purchaseModel ? purchaseModel.purgoods_En : "";
			},
			auditstatulist() {
				return [{
						value: 0,
						label: this.$t("subscribe.statelist[1]"),
						color: "blue"
					},
					{
						value: 1,
						label: this.$t("subscribe.statelist[2]"),
						color: "green"
					},
					{
						value: 2,
						label: this.$t("subscribe.statelist[3]"),
						color: "red"
					},
					{
						value: 5,
						label: this.$t("subscribe.statelist[4]"),
						color: "grey"
					},
					{
						value: 23,
						label: this.$t("subscribe.statelist[5]"),
						color: "#55ffff"
					}
				];
			},
			auditstatulist1() {
				return [{
						value: 1,
						label: this.$t("subscribe.statelist[2]"),
						color: "green"
					},
					{
						value: 2,
						label: this.$t("subscribe.statelist[3]"),
						color: "red"
					},
					{
						value: 23,
						label: this.$t("subscribe.statelist[5]"),
						color: "#55ffff"
					}
				];
			},
			tableHead() {
				return [{
						prop: "BudgetType",
						label: this.$t("DepartBudgetBalanceRpt.tableLabel[2]")
					},
					{
						prop: "budget",
						label: this.$t("subscribe.statelist[10]")
					},
					{
						prop: "totalPurAmount",
						label: this.$t("subscribe.labellist[21]")
					}
					// {
					// 	prop: 'withoutAfterAmount',
					// 	label: this.$t('subscribe.labellist[24]')
					// },
					// {
					// 	prop: 'ApprovedAmount',
					// 	label: this.$t('subscribe.labellist[23]')
					// },
					// {
					// 	prop: 'currentBudgetAmount',
					// 	label: this.$t('subscribe.statelist[9]')
					// },
					// {
					// 	prop: 'shortEng',
					// 	label: this.$t('subscribe.labellist[7]')
					// },
					// {
					// 	prop: 'year',
					// 	label: this.$t('PaymentSummaryRpt.tableLabel[9]')
					// },
					// {
					// 	prop: 'month',
					// 	label: this.$t('PaymentSummaryRpt.tableLabel[8]')
					// },
				];
			}
		}),
		watch: {
			isShowSubscribe(newVal, oldVal) {
				// if (newVal) this.getDepartBudgetInfo();
				if (newVal) {
					this.base_deptname = this.subscribeOrder.deptname;
					this.base_deptnameid = this.subscribeOrder.deptid;
					this.getDepartGroupList(this.subscribeOrder.deptid);
					this.inputNum();
				}
				// console.log(this.subscribeOrder.deptid);
				// console.log(this.subscribeOrder.deptname);
			}
		}
	};
</script>

<style>
	.formtable .el-form-item__content {
		width: 100%;
	}

	.AddSubscribeOrderdemodialog .el-dialog {
		margin-top: 1vh !important;
		margin: 0 auto;
	}

	.AddSubscribeOrderdemodialog::-webkit-scrollbar {
		width: 0 !important;
	}

	.showText .el-textarea__inner:disabled {
		color: #000000;
	}

	.el-input.is-disabled .el-input__inner {
		color: #000000;
	}

	.auditclass {
		width: 50%;
		margin: 0 200px;
	}

	.auditclass .el-form-item__content {
		width: 100%;
	}

	.budgetelinput input {
		color: red !important;
	}

	/* .el-table__body-wrapper{
  overflow: unset !important;
} */

	/* .el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: auto;
} */

	.el-table__body-wrapper {
		overflow: auto !important;
	}

	/* .el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: auto;
} */
</style>


// WEBPACK FOOTER //
// src/components/common/PurchasingManagement/AddSubscribeOrder.vue